<template>
  <div id="admin-user-list">
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="User Requests" key="1">
        <common-user-list :userListData="userRequests"/>
      </a-tab-pane>
      <a-tab-pane tab="Course Submitters" key="2">
        <common-user-list :userListData="courseSubmitters"/>
      </a-tab-pane>
      <a-tab-pane tab="Admin Reviewers" key="3">
        <common-user-list :userListData="adminReviewers"/>
      </a-tab-pane>
      <a-tab-pane tab="Interim Reviewers" key="4">
        <common-user-list :userListData="interimReviewers"/>
      </a-tab-pane>
      <a-tab-pane tab="Certified Reviewers" key="5">
        <common-user-list :userListData="certifiedReviewers"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import commonUserList from '@src/components/dashboard/User-list.vue';

export default {
  name: 'telas-admin-user-list',
  components: {
    commonUserList,
  },
  computed: {
    ...mapGetters('dashboard', {
      courseSubmitters: 'getCourseSubmitters',
      certifiedReviewers: 'getCertifiedReviewers',
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapState('dashboard', {
      userInsName: state => state.userDetails.institution_name,
    }),
    ...mapState('dashboard', {
      userRequests: state => state.userRequestsList,
      adminReviewers: state => state.adminReviewersList,
      interimReviewers: state => state.interimReviewersList,
    }),
  },
  mounted() {
    this.$nextTick(() => {
      const userRequestArgs = {
        'meta[0][key]': 'activated_by_admin',
        'meta[0][value]': 'no',
        tab: 'userRequests',
        userToken: this.userToken,
      };
      this.getUserByMeta(userRequestArgs);
      const getCertifiedReviewersUsersArgs = {
        roles: 'telas_assessor',
        'meta[0][key]': 'telas_assessor_level',
        'meta[0][value]': 'telas_certified_reviewers',
        'meta[1][key]': 'activated_by_admin',
        'meta[1][value]': 'yes',
        tab: 'certifedReviewers',
        userToken: this.userToken,
      };
      this.getUserByMeta(getCertifiedReviewersUsersArgs);
      const getCourseSubmitterArgs = {
        roles: 'telas_course_submitters',
        'meta[0][key]': 'activated_by_admin',
        'meta[0][value]': 'yes',
        tab: 'courseSubmitters',
        userToken: this.userToken,
      };
      this.getUserByMeta(getCourseSubmitterArgs);
      const getInterimReviewersArgs = {
        roles: 'telas_assessor',
        'meta[0][key]': 'telas_assessor_level',
        'meta[0][value]': 'telas_interim_reviewers',
        'meta[1][key]': 'activated_by_admin',
        'meta[1][value]': 'yes',
        tab: 'interimReviewers',
        userToken: this.userToken,
      };
      this.getUserByMeta(getInterimReviewersArgs);
      const getAdminReviewersArgs = {
        roles: 'telas_assessor',
        'meta[0][key]': 'telas_assessor_level',
        'meta[0][value]': 'telas_admin_reviewers',
        'meta[1][key]': 'activated_by_admin',
        'meta[1][value]': 'yes',
        tab: 'adminReviewers',
        userToken: this.userToken,
      };
      this.getUserByMeta(getAdminReviewersArgs);
    });
  },
  methods: {
    ...mapActions('dashboard', {
      getUserByMeta: 'getUserByMeta',
    }),
  },
  created() {
    this.$store.watch(
      (state, getters) => getters['user/getUserToken'],
      // eslint-disable-next-line
      (newValue, oldValue) => {

      },
    );
  },
};
</script>
